import { RefObject, useLayoutEffect, useState } from 'react';

const BOTTOM_GAP = 8;

const measureMargin = (table: HTMLElement, footer: HTMLElement | null) =>
    Math.ceil(table.getBoundingClientRect().top + window.scrollY + (footer?.offsetHeight ?? 0) + BOTTOM_GAP);

export const useViewportFitMargin = (
    enabled: boolean,
    rootRef: RefObject<HTMLElement>,
    tableRef: RefObject<HTMLElement>,
    footerRef: RefObject<HTMLElement>,
): number | undefined => {
    const [margin, setMargin] = useState<number>();

    useLayoutEffect(() => {
        const root = rootRef.current;
        const table = tableRef.current;
        if (!enabled || !root || !table) return undefined;
        const update = () => setMargin(measureMargin(table, footerRef.current));
        update();
        window.addEventListener('resize', update);
        if (typeof ResizeObserver === 'undefined') {
            return () => window.removeEventListener('resize', update);
        }
        const observer = new ResizeObserver(update);
        observer.observe(root);
        if (footerRef.current) observer.observe(footerRef.current);
        return () => {
            observer.disconnect();
            window.removeEventListener('resize', update);
        };
    }, [enabled, rootRef, tableRef, footerRef]);

    return margin;
};
